import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
var _excluded = ["defaultFetcher", "onInputValueChange", "value", "onValueChange", "noResultMessage", "defaultValue", "loadingAriaLabel", "multiselect", "disabled"],
    _excluded2 = ["value", "displayValue"];
import "../../../../styles/combobox-with-api-pagination.css";
import { ComboboxItemValue as $ } from "@ariakit/react";
import { Combobox as m, LoadingIndicator as oo, InlineNotice as eo, Text as to } from "@box/blueprint-web";
import { useForkRef as ro } from "@box/blueprint-web/lib-esm/utils/useForkRef";
import { Search as no, Loader as io } from "@box/blueprint-web-assets/icons/Fill";
import { IconIconOnLightSecondary as ao, Size6 as M, Size1 as so } from "@box/blueprint-web-assets/tokens/tokens";
import lo from "clsx";
import { forwardRef as S, useRef as C, useCallback as co, useMemo as L, useEffect as uo } from "react";
import { useIntl as F, FormattedMessage as T } from "react-intl";
import i from "./messages.js";
import { useAsyncList as mo } from "./use-async-list.js";
import { useControllableState as po } from "./utils/use-controllable-state.js";
import { useTrackVisibility as ho } from "./utils/use-intersection-observer.js";
import { jsx as r, jsxs as V, Fragment as fo } from "react/jsx-runtime";
var bo = "_container_181ao_1",
    go = "_disabled_181ao_7",
    xo = "_highlightOptionText_181ao_11",
    Oo = "_option_181ao_24",
    _o = "_errorComboboxOption_181ao_28",
    Ro = "_errorComboboxOptionText_181ao_33",
    c = {
  container: bo,
  disabled: go,
  highlightOptionText: xo,
  option: Oo,
  errorComboboxOption: _o,
  errorComboboxOptionText: Ro
},
    N = /* @__PURE__ */S(function (_ref, p) {
  var y = _ref.onTryAgain;

  var _F = F(),
      h = _F.formatMessage;

  return /* @__PURE__ */V(fo, {
    children: [/* @__PURE__ */r(eo, {
      variant: "error",
      variantIconAriaLabel: h(i.loadingResultsErrorIconLabel),
      children: /* @__PURE__ */r(T, _objectSpread({}, i.loadingResultsErrorMessage))
    }), /* @__PURE__ */r(m.Option, {
      ref: p,
      className: c.errorComboboxOption,
      onClick: y,
      children: /* @__PURE__ */V(to, {
        as: "span",
        className: c.errorComboboxOptionText,
        color: "textOnLightLink",
        variant: "bodyDefaultBold",
        children: [/* @__PURE__ */r(T, _objectSpread({}, i.loadingResultsErrorAction)), /* @__PURE__ */r(io, {
          color: "currentColor",
          height: "12px",
          width: "12px"
        })]
      })
    })]
  });
}),
    A = "__LOADING__",
    E = "__LOADING_ERROR__",
    Co = "0px 0px 20px 0px",
    Lo = /* @__PURE__ */r(no, {
  color: ao,
  height: M,
  role: "presentation",
  style: {
    padding: so,
    boxSizing: "border-box"
  },
  width: M
}),
    wo = /* @__PURE__ */S(function (p, h) {
  var P = p.defaultFetcher,
      f = p.onInputValueChange,
      k = p.value,
      D = p.onValueChange,
      w = p.noResultMessage,
      _p$defaultValue = p.defaultValue,
      B = _p$defaultValue === void 0 ? [] : _p$defaultValue,
      W = p.loadingAriaLabel,
      _p$multiselect = p.multiselect,
      s = _p$multiselect === void 0 ? !1 : _p$multiselect,
      z = p.disabled,
      G = _objectWithoutProperties(p, _excluded),
      _F2 = F(),
      u = _F2.formatMessage,
      b = C(null),
      g = C(!0),
      o = mo({
    load: function load(_ref2) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var e, t, R, l;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e = _ref2.marker, t = _ref2.searchInput, R = _ref2.signal;
                _context.next = 3;
                return P({
                  signal: R,
                  marker: e,
                  searchInput: t
                });

              case 3:
                l = _context.sent;
                return _context.abrupt("return", {
                  items: l.options,
                  marker: l.marker
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }),
      v = C(!1),
      j = co(function () {
    v.current || (o.reload(), v.current = !0);
  }, []),
      _po = po({
    prop: k,
    defaultProp: B,
    onChange: D
  }),
      _po2 = _slicedToArray(_po, 2),
      n = _po2[0],
      x = _po2[1],
      O = !s && n.length === 1,
      U = function U(e) {
    e === void 0 ? (x([]), g.current || (o.search(""), g.current = !0)) : Array.isArray(e) ? x(e) : x([e]);
  },
      q = L(function () {
    return n.length === 0 ? s ? [] : void 0 : s ? n : n[0];
  }, [s, n]),
      _ = L(function () {
    return n.filter(function (e) {
      return !o.items.some(function (t) {
        return t.value === e.value;
      });
    });
  }, [n, o.items]),
      H = function H(e) {
    var t = e.value,
        R = e.displayValue,
        l = _objectWithoutProperties(e, _excluded2);

    if (t === A) return o.hasNextPage ? /* @__PURE__ */r(m.Option, _objectSpread(_objectSpread({}, l), {}, {
      ref: Q,
      disabled: !0,
      value: t,
      children: /* @__PURE__ */r(oo, {
        "aria-label": u(i.loadingMoreAriaLabel),
        style: {
          position: "unset"
        }
      })
    })) : null;
    if (t === E && o.hasError && !o.isEmpty) return /* @__PURE__ */r(N, {
      onTryAgain: function onTryAgain() {
        var a;
        o.loadMore(), (a = b.current) == null || a.focus();
      }
    });
    if (_.some(function (a) {
      return a.value === t;
    })) return null;

    var Z = function Z() {
      return n.some(function (a) {
        return a.value === t;
      });
    };

    return /* @__PURE__ */r(m.Option, _objectSpread(_objectSpread({}, l), {}, {
      className: c.option,
      disabled: Z(),
      value: t,
      children: /* @__PURE__ */r($, {
        className: c.highlightOptionText,
        value: R || t
      })
    }));
  },
      J = function J(e) {
    if (f == null || f(e), O && e === "") {
      g.current = !1;
      return;
    }

    o.search(e);
  },
      K = function K() {
    var e;
    o.reload(), (e = b.current) == null || e.focus();
  };

  var d;
  o.hasError && !o.isLoading ? d = /* @__PURE__ */r(N, {
    onTryAgain: K
  }) : o.isEmpty && !o.isLoading ? d = w || u(i.noResults) : d = void 0;

  var _ho = ho({
    rootMargin: Co
  }),
      _ho2 = _slicedToArray(_ho, 2),
      Q = _ho2[0],
      _ho2$ = _ho2[1],
      X = _ho2$.rootRef,
      I = _ho2$.isVisible;

  uo(function () {
    if (!(I && o.hasNextPage)) return;
    var t = setTimeout(function () {
      o.loadMore();
    }, 100);
    return function () {
      clearTimeout(t);
    };
  }, [I]);
  var Y = L(function () {
    var e = o.hasNextPage ? {
      displayValue: A,
      value: A
    } : null,
        t = !e && o.hasError && !o.isEmpty ? {
      displayValue: E,
      value: E
    } : null;
    return [].concat(_toConsumableArray(o.items), _toConsumableArray(_), [e, t]).filter(Boolean);
  }, [o.hasNextPage, o.hasError, o.isEmpty, o.items, _]);
  return /* @__PURE__ */r(m, _objectSpread(_objectSpread({
    as: "input"
  }, G), {}, {
    ref: ro(b, h),
    className: lo(_defineProperty({}, c.disabled, O)),
    clearButtonAriaLabel: u(i.clearButtonAriaLabel),
    disabled: z || O,
    displayValue: function displayValue(e) {
      return e.displayValue || e.value;
    },
    endComboboxIcon: Lo,
    focusLoop: !1,
    getPopoverRef: X,
    loading: o.isReloading,
    loadingAriaLabel: W || u(i.loadingAriaLabel),
    multiselect: s,
    noResultMessage: d,
    onFocus: j,
    onInputValueChange: J,
    onValueChange: U,
    options: Y,
    renderOption: H,
    value: q
  }));
});
export { wo as ComboboxWithApiPagination };